import { Mail, ChevronDown } from "lucide-react";
import { Reveal } from "../components/shared";
import { Caps, H2 } from "../components/site";
import { PATHWAYS, CONTACT } from "../content";

const mailto = ({ subject, q }) => {
  const body = ["Hello Inner You Development team,", "", ...q.map((x) => `${x}: `), "", "Please attach any referral letter or plan to this email.", "", "Thank you"].join("\n");
  return `${CONTACT.emailHref}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

const PathwayCard = ({ p, i }) => (
  <Reveal delay={(i % 3) * 0.06} className="h-full">
    <article id={p.id} data-testid={`pathway-${p.id}`} className="scroll-mt-28 h-full flex flex-col rounded-[28px] bg-[#FBF9F4] border border-[#3F4A3C]/10 p-6">
      <div className="flex items-center gap-4">
        <span className="w-12 h-12 shrink-0 rounded-full bg-[#3F4A3C] grid place-items-center ring-1 ring-offset-2 ring-offset-[#FBF9F4] ring-[#C59B45]/60"><p.icon className="w-5 h-5 text-[#F6F2E9]" strokeWidth={1.5} /></span>
        <h3 className="font-newsreader text-xl leading-tight text-[#3F4A3C]">{p.title}</h3>
      </div>
      <p className="mt-3 font-jakarta text-sm text-[#4A4F45]">{p.who}</p>
      <details className="group mt-5 flex-1" data-testid={`pathway-steps-${p.id}`}>
        <summary className="list-none cursor-pointer inline-flex items-center gap-2 font-jakarta text-sm text-[#3F4A3C] underline underline-offset-4">How it works <ChevronDown className="w-4 h-4 transition-transform group-open:rotate-180" /></summary>
        <ol className="mt-4 space-y-3">
          {p.steps.map((s, n) => (
            <li key={s} className="flex gap-3 font-jakarta text-sm leading-relaxed text-[#4A4F45]">
              <span className="w-6 h-6 shrink-0 rounded-full bg-[#3F4A3C] text-[#F6F2E9] grid place-items-center text-xs">{n + 1}</span>{s}
            </li>
          ))}
        </ol>
        <p className="mt-4 font-jakarta text-xs leading-relaxed text-[#5E6B57]">{p.note}</p>
      </details>
      {p.email && (
        <a href={mailto(p.email)} data-testid={`pathway-email-${p.id}`} className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-[#3F4A3C] px-5 py-3 font-jakarta text-sm text-[#F6F2E9] hover:bg-[#5F7C8A] transition-colors">
          <Mail className="w-4 h-4" /> {p.email.label}
        </a>
      )}
    </article>
  </Reveal>
);

export const PathwaysSection = () => (
  <div id="pathways" className="scroll-mt-28 border-t border-[#3F4A3C]/10 pt-16 sm:pt-20" data-testid="pathways-section">
    <div className="max-w-[1360px] mx-auto px-5 sm:px-10 pb-8">
      <Caps>Referral pathways</Caps>
      <H2 className="mt-4">Every way in, <em className="text-[#5F7C8A]">made simple.</em></H2>
      <p className="mt-4 max-w-2xl font-jakarta text-base text-[#4A4F45]">Choose the pathway that fits. Not sure? Just ask us.</p>
    </div>
      <section className="max-w-[1360px] mx-auto px-5 sm:px-10 pb-12 grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="pathways-grid">
        {PATHWAYS.map((p, i) => <PathwayCard key={p.id} p={p} i={i} />)}
      </section>
  </div>
);
